import merge from 'lodash.merge'
import { submissionService } from '@oneblink/apps'
import { SubmissionTypes } from '@oneblink/types'
import config from '../../config'

export function mergeSubmissions(
  originalSubmission: SubmissionTypes.S3SubmissionData,
  vetDecSubmission: submissionService.NewFormSubmission,
): submissionService.FormSubmission {
  const mergedSubmissionData = merge(originalSubmission.submission, {
    Vet_continue: ['Continue to veterinarian declaration for completion.'],
    vetDeclaration: vetDecSubmission.submission,
  })

  const formSubmission: submissionService.FormSubmission = {
    formsAppId: originalSubmission.formsAppId,
    jobId: null,
    externalId: originalSubmission.externalId ?? null,
    draftId: null,
    preFillFormDataId: null,
    submission: mergedSubmissionData,
    definition: {
      ...originalSubmission.definition,
      id: config.VET_DEC_FORM_ID,
    },
    captchaTokens: [],
  }

  return formSubmission
}
